module.exports = __webpack_public_path__ + "img/logo2.92da42b2.svg";